<style lang="scss"></style>

<template>
  <LayoutHeader v-if="systemStore.showHeader" />
  <el-config-provider :locale="zhCn">
    <router-view />
    <PartnerJoinProcessDialog ref="partnerJoinProcessDialog" />
    <CooperationModeDialog ref="cooperationModeDialog" />
  </el-config-provider>
  <LayoutFooter v-if="systemStore.showFooter" />
</template>

<script setup>
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { JOIN_STATUS } from '@/views/components/partner-join/common/data'
import CooperationModeDialog from '@/views/components/partner-join/cooperation-mode-dialog.vue'
import PartnerJoinProcessDialog from '@/views/components/partner-join/partner-join-process-dialog.vue'
import LayoutFooter from '@/views/layout/layout-footer.vue'
import LayoutHeader from '@/views/layout/layout-header.vue'
import { useSystemStore, useUserStore } from '@/stores/index'
import { useEvent } from '@/event/index'
import { CLOSE_JOIN_CORP_DIALOG, LOGOUT, OPEN_JOIN_CORP_DIALOG, OPEN_PARTNER_MODE_DIALOG, REFRESH_JOIN_CORP_STATUS } from '@/event/modules/site'
import { broadcastChannel } from '@/utils/window-event'
import { WEB_SOCKET_EVENT } from '@/websocket/constant'
import { useWebsocketEvent } from '@/websocket/index.js'

const event = useEvent()
const useWebsocket = useWebsocketEvent()
const route = useRoute()

const systemStore = useSystemStore()
const userStore = useUserStore()

const partnerJoinProcessDialog = ref(null) //合伙人入驻流程窗口
const cooperationModeDialog = ref(null) //合伙人模式选择窗口

watch(
  () => userStore.isLogined,
  (val) => {
    console.log(val, 'loged')
    if (val) {
      // 获取用户入驻信息
      userStore.getAccountInfo()
      // 连接mqtt
      userStore.connectMqtt()
    } else {
      // 断开mqtt
      userStore.disconnectMqtt()
    }
  },
)
onMounted(async () => {
  // 退出登录
  event.on(LOGOUT, () => {
    //记录上一次的路由地址
    const { path } = route
    userStore.logout(path ? `/login?fromPath=${path.replace(/^\/+/, '')}` : '/login')
  })

  broadcastChannel.listenerMessage()

  if (userStore.isLogined) {
    // 获取用户入驻信息
    userStore.getAccountInfo()
    await userStore.connectMqtt()
    console.log('mounted')
  }

  //监听打开合伙人入驻流程窗口
  event.on(OPEN_JOIN_CORP_DIALOG, (e) => {
    partnerJoinProcessDialog.value && partnerJoinProcessDialog.value.open(e)
  })

  //监听关闭合伙人入驻流程窗口
  event.on(CLOSE_JOIN_CORP_DIALOG, () => {
    partnerJoinProcessDialog.value && partnerJoinProcessDialog.value.close()
  })

  //监听打开合伙人模式选择窗口
  event.on(OPEN_PARTNER_MODE_DIALOG, () => {
    cooperationModeDialog.value && cooperationModeDialog.value.open()
  })

  //入驻审核mqtt消息监听
  useWebsocket.on(WEB_SOCKET_EVENT.OPERATION_MESSAGE_NOTICE, (e) => {
    const { applyStatus } = e || {}

    //入驻成功
    if (applyStatus === JOIN_STATUS.SUCCESS) {
      event.emit(CLOSE_JOIN_CORP_DIALOG)
      // window.open('/partner-joined', '_blank')
    }
    //入驻审核驳回 或 审核通过
    if ([JOIN_STATUS.AUDIT_REJECT, JOIN_STATUS.WAIT_SIGN].includes(applyStatus)) {
      event.emit(REFRESH_JOIN_CORP_STATUS)
    }
    // 更新用户入驻信息
    userStore.getAccountInfo()
  })
})
</script>
